import { render, staticRenderFns } from "./CellType.vue?vue&type=template&id=2168dc45&scoped=true&"
import script from "./CellType.vue?vue&type=script&lang=js&"
export * from "./CellType.vue?vue&type=script&lang=js&"
import style0 from "./CellType.vue?vue&type=style&index=0&id=2168dc45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2168dc45",
  null
  
)

export default component.exports